import {Component, Inject, OnInit} from '@angular/core';
import {NotificationsService} from '../notifications.service';
import {Notifications} from '../notifications.enum';
import {UserService} from '../../../shared/user.service';
import {CurrentDayService} from '../../../shared/current-day.service';
import * as angular from 'angular';
import {ParsedFinishWorkEmployeeTime, ParsedStartWorkEmployeeTime, WorkingTimeService} from '../working-time.service';
import {Employee} from 'resteasytox';

@Component({
	selector: 'tt-working-time-notification',
	templateUrl: './working-time-notification.component.html',
	styleUrls: ['./working-time-notification.component.scss']
})
export class WorkingTimeNotificationComponent {

	accountedTimePercents: number = 0;
	accountedTimeMinPercents: number = 75;
	accountedHours: number = 0;
	workingTime: number = 0;

	employeeStartWorkHours: number = null;
	employeeStartWorkMinutes: number = null;

	employeeFinishWorkHours: number = null;
	employeeFinishWorkMinutes: number = null;

	isWorkedFullDay: boolean = false;

	showWorkingTimeNotification: boolean = false;

	private now: Date;
	private currentDate: Date;

	constructor(private notificationsService: NotificationsService,
				private userService: UserService,
				private currentDayService: CurrentDayService,
				private workingTimeService: WorkingTimeService,
				@Inject('$rootScope') private rootScopeService: angular.IRootScopeService) {
		this.now = new Date();
		this.currentDate = currentDayService.currentDay;

		this.rootScopeService.$on('current',
			(e: angular.IAngularEvent, current: Date) => this.currentDate = new Date(current.getTime()));

		this.rootScopeService.$on('userDetailsLoaded',
			(e: angular.IAngularEvent, user: any) => this.updateNotification());

		this.rootScopeService.$on('getCombinedTotal',
			(e: angular.IAngularEvent, user: any) => this.updateNotification());

		if (this.userService.user) {
			this.updateNotification();
		}

	}
	updateNotification(): void {
		const user: Employee = this.userService.user;
		const currentUserId: number = user.id;

		if (user.startWorkTime) {
			this.parseEmployeeStartWorkTime(user.startWorkTime);
		}
		if (user.finishWorkTime) {
			this.parseEmployeeFinishWorkTime(user.finishWorkTime);
		}

		this.updateNotificationInternal();
	}

	isWorkingTimeNotificationDisplayed(): boolean {
		const isToday: boolean = (
			this.now.getDate() === this.currentDate.getDate() &&
			this.now.getMonth() === this.currentDate.getMonth() &&
			this.now.getFullYear() === this.currentDate.getFullYear()
		);
		return this.showWorkingTimeNotification && isToday && !this.isWeekend() && this.notificationsService.isNotificationAvailable(Notifications.WORKING_TIME);
	}

	closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.WORKING_TIME);
	}

	private isWeekend(): boolean {
		const day: number = new Date().getDay();
		return day === 6 || day === 0;
	}

	private updateNotificationInternal(): void {
		if (!this.employeeStartWorkHours) {
			return;
		}

		this.notificationsService
			.getDailyDetailsForEmployee()
			.map((details: any) =>
				this.accountedHours = details.reduce((acc: number, item: any) => acc + item.hours, 0))
			.subscribe(() => this.checkWorkingTime());

	}

	private checkWorkingTime(): void {
		this.now = new Date();

		const hour: number = 60 * 60 * 1000;
		const startWork: Date = new Date();
		const finishWork: Date = new Date();

		startWork.setHours(this.employeeStartWorkHours);
		startWork.setMinutes(this.employeeStartWorkMinutes);

		finishWork.setHours(this.employeeFinishWorkHours);
		finishWork.setMinutes(this.employeeFinishWorkMinutes);

		this.workingTime = this.now.getTime() - startWork.getTime();

		if (this.workingTime < 3 * hour) {
			this.showWorkingTimeNotification = false;
			return;
		}


		if (this.now.getTime() > finishWork.getTime()) {
			this.isWorkedFullDay = true;
		}

		this.showWorkingTimeNotification = true;

		// Calculate actual work time (elapsed time minus 1hr unpaid lunch)
		const actualWorkTimeHours = Math.max(1, (this.workingTime / hour) - 1);
		
		if (this.accountedHours >= 8) {
			this.accountedTimePercents = 100;
		} else {
			// Use actual work time (elapsed time - 1hr lunch) instead of fixed 8hrs
			// This way short days (6hrs) and long days (10hrs) are calculated correctly
			// Example: 9hrs elapsed - 1hr lunch = 8hrs work, so 7hrs logged = 87.5%
			this.accountedTimePercents = <any> ((this.accountedHours / actualWorkTimeHours) * 100).toFixed(0);
		}
	}

	private parseEmployeeStartWorkTime(time: string): void {
		const result: ParsedStartWorkEmployeeTime = this.workingTimeService.parseEmployeeStartWorkTime(time);
		this.employeeStartWorkHours = result.employeeStartWorkHours;
		this.employeeStartWorkMinutes = result.employeeStartWorkMinutes;
	}

	private parseEmployeeFinishWorkTime(time: string): void {
		const result: ParsedFinishWorkEmployeeTime  = this.workingTimeService.parseEmployeeFinishWorkTime(time);
		this.employeeFinishWorkHours = result.employeeFinishWorkHours;
		this.employeeFinishWorkMinutes = result.employeeFinishWorkMinutes;
	}


}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/working-time-notification/working-time-notification.component.ts